import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  ogImage,
  ogType = 'website',
  canonical,
  noindex = false
}) => {
  const siteTitle = 'The Grazing Trust';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Scottish Equine Sanctuary & Welfare Organisation`;
  const siteUrl = 'https://thegrazingtrust.org';
  const defaultDescription = 'Nonprofit Association providing safe refuge, rehabilitation, and rehoming for horses in need across Scotland. Natural-living sanctuary care for equines who can no longer be cared for by their owners.';
  const defaultImage = 'https://images.unsplash.com/photo-1656238728485-ac9aca296131?w=1200&h=630&auto=format&fit=crop';
  
  const pageDescription = description || defaultDescription;
  const pageImage = ogImage || defaultImage;
  const pageUrl = canonical || siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={pageDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={pageUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={pageDescription} />
      <meta property="twitter:image" content={pageImage} />
    </Helmet>
  );
};

export default SEO;
